export function omit<T extends object, K extends readonly (keyof T)[]>(
  obj: T,
  keys: K
): Omit<T, K[number]> {
  const rest: Partial<T> = { ...obj };
  for (const key of keys) {
    delete rest[key];
  }
  return rest as Omit<T, K[number]>;
}
